import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import LanguageProvider from "./i18n/LanguageProvider";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

const MIN_LOADER_TIME_MS = 850;
const LOADER_FADE_MS = 320;

function renderApp() {
  root.render(
    <React.StrictMode>
      <LanguageProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </LanguageProvider>
    </React.StrictMode>
  );

  document.documentElement.classList.remove("paranoidi-show-start-loader");
  reportWebVitals();
}

const shouldShowLoader = document.documentElement.classList.contains(
  "paranoidi-show-start-loader"
);

const loader = rootElement?.querySelector(".paranoidi-loader");

if (!shouldShowLoader || !loader) {
  renderApp();
} else {
  window.setTimeout(() => {
    loader.classList.add("paranoidi-loader--fade-out");

    window.setTimeout(() => {
      renderApp();
    }, LOADER_FADE_MS);
  }, MIN_LOADER_TIME_MS);
}